<template>
  <footer class="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
      <div class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        <div class="text-center md:text-left">
          <p class="text-sm text-gray-600 dark:text-gray-300">
            © {{ currentYear }} Halo 统计分析
          </p>
        </div>

        <div class="flex items-center space-x-6">
          <a
            href="https://github.com/AR-26710/halo-site-statistical-analysis"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
            aria-label="GitHub"
          >
            <Icon
              icon="simple-icons:github"
              class="w-5 h-5"
            />
          </a>

          <a
            href="https://github.com/halo-dev/halo"
            target="_blank"
            class="text-sm text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            Halo 仓库
          </a>

          <a
            href="https://api.halo.run/"
            target="_blank"
            class="text-sm text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            Halo API 文档
          </a>
        </div>
      </div>

      <div class="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
        <div class="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 dark:text-gray-400 space-y-2 md:space-y-0">
          <div>
            数据更新时间: {{ lastUpdateTime }}
          </div>
          <div class="flex items-center space-x-4">
            <span>版本: v{{ version }}</span>
            <span>•</span>
            <span>
              Powered by
              <a
                href="https://vuejs.org/"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >Vue 3</a>
              +
              <a
                href="https://tailwindcss.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >Tailwind CSS</a>
              +
              <a
                href="https://www.chartjs.org/"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >Chart.js</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { version } from '../../../package.json'

const currentYear = new Date().getFullYear()

defineProps<{
  lastUpdateTime: string
}>()
</script>
